import PortalHome from './PortalHome';

export default PortalHome;
